import React from 'react'
import {MdEdit} from 'react-icons/md';
import {Button, Media} from "reactstrap";

import LocalizedStrings from "react-localization";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import {student_strings} from "../../translations/student_translations";
import {resource_strings} from "../../translations/resource_translations";
import businessHelper from "../../helpers/BusinessHelper";

let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

class PerClassTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paymentInfo: props.paymentInfo,
            cur: businessHelper.currency(),
        };
    }

    componentWillUpdate(nextProps, nextState, nextContext) {

    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    render() {
        this.localize();
        return (

            <tr onClick={e => this.props.editPaymentInfo(e, this.state.paymentInfo)}>
                <th scope="row">
                        <span>
                        {this.state.paymentInfo.className}
                        </span>
                    <div className="align-items-center">
                        <small>
                            <div >
                            {this.paymentData()}
                            </div>
                        </small>
                    </div>
                </th>
                <td className="text-right align-content-end">
                    <div>
                        <Button
                            className="btn-icon ct-example-tooltip-static"
                            color="warning"
                            data-type="error"
                            data-tip={studentStrings.remove_from_class}
                            onClick={e => this.props.editPaymentInfo(e, this.state.paymentInfo)}>
                            <MdEdit/>
                        </Button>
                    </div>
                </td>
            </tr>
        )
    }

    paymentData() {
        return resourceStrings.per_class + ": " + this.state.cur + this.perClass() + ", " + resourceStrings.per_client + ": " + this.state.cur + this.perClient();
    }

    perClass() {
        return (this.state.paymentInfo.perClass / 100).toFixed(2);
    }

    perClient() {
        return (this.state.paymentInfo.perStudent / 100).toFixed(2);
    }
}

PerClassTableRow.propTypes = propTypes;

export default PerClassTableRow;